import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, inject } from '@angular/core'

import { Subject, fromEvent } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

import { AnalyticsAction, AnalyticsObject, AnalyticsService } from './analytics.service'

export interface AnalyticsEventParams {
  object: AnalyticsObject
  action: AnalyticsAction
  properties: { [key: string]: any }
}

@Directive({
  selector: '[flxAnalyticsEvent]',
})
export class AnalyticsEventDirective implements AfterViewInit, OnDestroy {
  #destroyed$ = new Subject<void>()
  #el = inject(ElementRef).nativeElement
  #analyticsService = inject(AnalyticsService)

  @Input() flxAnalyticsEvent: string
  @Input() flxAnalyticsParams: AnalyticsEventParams

  ngAfterViewInit(): void {
    fromEvent(this.#el, this.flxAnalyticsEvent)
      .pipe(takeUntil(this.#destroyed$))
      .subscribe(() => {
        this.#analyticsService.trackUntyped(
          {
            object: this.flxAnalyticsParams.object,
            action: this.flxAnalyticsParams?.action,
          },
          this.flxAnalyticsParams?.properties
        )
      })
  }

  ngOnDestroy(): void {
    setTimeout(() => {
      this.#destroyed$.next()
      this.#destroyed$.complete()
    }, 1000)
  }
}
